import type { IBaseItem } from '@shiftsmartinc/shiftsmart-types';

import _ from 'lodash';

import BaseStore from './_baseStore';

export type INoShowRemediationUploader = IBaseItem & Record<string, unknown>;

export default class NoShowRemediationUploaderStore extends BaseStore<INoShowRemediationUploader> {
  constructor() {
    const baseItem = { csvFile: '' };
    super({ baseItem, serviceName: 'noShowRemediationUploader' });

    this.selected = _.clone(this.baseItem);

    return this;
  }
}
